import { render, staticRenderFns } from "./EmploymentTag.vue?vue&type=template&id=0902a639&lang=pug&"
import script from "./EmploymentTag.vue?vue&type=script&lang=ts&"
export * from "./EmploymentTag.vue?vue&type=script&lang=ts&"
import style0 from "./EmploymentTag.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmploymentTag.vue"
export default component.exports